import { forwardRef, useId, type TextareaHTMLAttributes } from 'react';

export interface TextAreaFieldProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  hint?: string;
}

const TextAreaField = forwardRef<HTMLTextAreaElement, TextAreaFieldProps>(function TextAreaField({ label, error, hint, id, className = '', ...rest }, ref) {
  const autoId = useId();
  const fieldId = id ?? autoId;
  return (
    <div className={`field ${className}`}>
      {label && <label htmlFor={fieldId}>{label}</label>}
      <textarea ref={ref} id={fieldId} className="textarea" aria-invalid={!!error || undefined} {...rest} />
      {error ? <span className="error">{error}</span> : hint ? <span className="hint">{hint}</span> : null}
    </div>
  );
});
export default TextAreaField;
